<template>
    <RouterButton
        link="/contacts/person/add"
        text='contacts.actions.add_person'
        icon='fas fa-user-plus'
        class="clear"
    />
    <RouterButton
        link="/contacts/group/add"
        text='contacts.actions.add_group'
        icon='fas fa-user-plus group-plus'
        class="clear"
    />

    <hr />

    <RouterButton
        link="/contacts/import"
        icon='fas fa-download'
        text="contacts.actions.import"
        class="clear"
    />
    <RouterButton
        link="/contacts/export"
        icon='fas fa-upload'
        text="contacts.actions.export"
        class="clear"
    />

    <RouterButton
        link="/contacts/duplicates"
        icon='far fa-copy'
        text="contacts.actions.duplicated"
        class="clear"
    />
</template>

<script setup>
  import RouterButton from '@/vue/Elements/Buttons/RouterButton.vue';

  defineProps({
    zone : {
      default : null,
    }
  })
</script>
